<!--  卡片展示-->
<template>
  <div class="drawCard" v-show="show">
    <div class="box">
      <h1>{{ cardInfo.cardName }}</h1>
      <img :src="cardInfo.cardIcon" alt="" />
      <h2>拥有数量{{ cardInfo.cardCount||0 }}</h2>
      <div class="close" @click="changeShow"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },
  props: {
    cardInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {},
  methods: {
    changeShow() {
      this.show = !this.show;
    },
    drawCard() {
      this.$emit('');
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.drawCard {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  padding: 161px 116px 0 116px;
  background: rgba($color: #000, $alpha: 0.8);
  .box {
    width: 100%;
    min-height: 624px;
    h1 {
      padding-bottom: 31px;
      color: #fff;
      font-weight: 500;
      font-size: 40px;
      text-align: center;
    }
    img {
      width: 519px;
      height: 692px;
    }
    h2 {
      padding: 19px 0 34px 0;
      color: #fff;
      font-weight: 400;
      font-size: 26px;
      text-align: center;
    }
    .close {
      width: 66px;
      height: 66px;
      margin: 0 auto;
      background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/close.png');
      background-size: 100%;
    }
  }
}
</style>
